
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _403_45GuPeWBZ1T_45clkWk_WG_45ZLXvv9u0zl4Yof5a_45HhUcVYMeta } from "/app/pages/403.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta } from "/app/pages/login.vue?macro=true";
import { default as signupXDZ9vem3RhITR7dUmFJxupvJgksTCjysSig_ObPaBwEMeta } from "/app/pages/signup.vue?macro=true";
import { default as settingsDGUPgOPonJUdwz8k5B4RVSmTRVCcKBNUebfgnD29s5kMeta } from "/app/pages/settings.vue?macro=true";
import { default as test_45formaCgQmKdxUqwqT0OnlVVKHIPKVVp7uxired97Vmx9WtIMeta } from "/app/pages/test-form.vue?macro=true";
import { default as forgot_45passwordgdzNcmliYSc_RqJLDFi4QKABybrSV1OTdLl0SK_45V07UMeta } from "/app/pages/forgot-password.vue?macro=true";
import { default as history5abFvAbdjq3Eo8BEFunaPrtazDD_45OQZFUuIjJch1EMwMeta } from "/app/pages/payment/history.vue?macro=true";
import { default as add_45card_34dcmAYIGcGfP6yZ6nE_45iNoExkt6UFgd98lDp69VDsMeta } from "/app/pages/payment/add-card.vue?macro=true";
import { default as checkoutQZu9KgMNqtNDnVL3wPsq_459Hgb4RiM2vFF1ZXYOnGVPQMeta } from "/app/pages/payment/checkout.vue?macro=true";
import { default as newEVaGznpi9BLqkzSTCRr_3b9t6GmJGBWnjXpIG4gFA9cMeta } from "/app/pages/prescription/new.vue?macro=true";
import { default as test_45credit_45cardD8ONM8Nj_zaKQGfK5qQc5QGsiyh5nlyaHFWzm8Ry3yYMeta } from "/app/pages/test-credit-card.vue?macro=true";
import { default as debug_45credit_45cardVxQ6URoTJg_tanC_eJZeARzxyU5PXa4BUTlpezSQzjIMeta } from "/app/pages/debug-credit-card.vue?macro=true";
import { default as credit_45cardXn9Lo4EF8ivB5Kmy6nw3VDwWzJMXW_4IG0F2L5A6NFkMeta } from "/app/pages/payment/credit-card.vue?macro=true";
import { default as searchppJMDPGZclD1xLVE6OUI8g9TGEgi_1JItMEQe1LI_4580Meta } from "/app/pages/prescription/search.vue?macro=true";
import { default as historynXI1xHYCYR7Kf_455OM1ZP8orwhnfsMMgSm4vGJJ4FzVYMeta } from "/app/pages/prescription/history.vue?macro=true";
import { default as bonus_45historyRcxraFtnnVtr8cyUQlMjoZ3Q0goJSGWyoOyDvKWOTt4Meta } from "/app/pages/payment/bonus-history.vue?macro=true";
export default [
  {
    name: "403___kk",
    path: "/kk/403",
    meta: _403_45GuPeWBZ1T_45clkWk_WG_45ZLXvv9u0zl4Yof5a_45HhUcVYMeta || {},
    component: () => import("/app/pages/403.vue")
  },
  {
    name: "403___ru",
    path: "/403",
    meta: _403_45GuPeWBZ1T_45clkWk_WG_45ZLXvv9u0zl4Yof5a_45HhUcVYMeta || {},
    component: () => import("/app/pages/403.vue")
  },
  {
    name: "403___en",
    path: "/en/403",
    meta: _403_45GuPeWBZ1T_45clkWk_WG_45ZLXvv9u0zl4Yof5a_45HhUcVYMeta || {},
    component: () => import("/app/pages/403.vue")
  },
  {
    name: "index___kk",
    path: "/kk",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "login___kk",
    path: "/kk/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___ru",
    path: "/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "signup___kk",
    path: "/kk/signup",
    meta: signupXDZ9vem3RhITR7dUmFJxupvJgksTCjysSig_ObPaBwEMeta || {},
    component: () => import("/app/pages/signup.vue")
  },
  {
    name: "signup___ru",
    path: "/signup",
    meta: signupXDZ9vem3RhITR7dUmFJxupvJgksTCjysSig_ObPaBwEMeta || {},
    component: () => import("/app/pages/signup.vue")
  },
  {
    name: "signup___en",
    path: "/en/signup",
    meta: signupXDZ9vem3RhITR7dUmFJxupvJgksTCjysSig_ObPaBwEMeta || {},
    component: () => import("/app/pages/signup.vue")
  },
  {
    name: "settings___kk",
    path: "/kk/settings",
    meta: settingsDGUPgOPonJUdwz8k5B4RVSmTRVCcKBNUebfgnD29s5kMeta || {},
    component: () => import("/app/pages/settings.vue")
  },
  {
    name: "settings___ru",
    path: "/settings",
    meta: settingsDGUPgOPonJUdwz8k5B4RVSmTRVCcKBNUebfgnD29s5kMeta || {},
    component: () => import("/app/pages/settings.vue")
  },
  {
    name: "settings___en",
    path: "/en/settings",
    meta: settingsDGUPgOPonJUdwz8k5B4RVSmTRVCcKBNUebfgnD29s5kMeta || {},
    component: () => import("/app/pages/settings.vue")
  },
  {
    name: "test-form___kk",
    path: "/kk/test-form",
    component: () => import("/app/pages/test-form.vue")
  },
  {
    name: "test-form___ru",
    path: "/test-form",
    component: () => import("/app/pages/test-form.vue")
  },
  {
    name: "test-form___en",
    path: "/en/test-form",
    component: () => import("/app/pages/test-form.vue")
  },
  {
    name: "forgot-password___kk",
    path: "/kk/forgot-password",
    meta: forgot_45passwordgdzNcmliYSc_RqJLDFi4QKABybrSV1OTdLl0SK_45V07UMeta || {},
    component: () => import("/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___ru",
    path: "/forgot-password",
    meta: forgot_45passwordgdzNcmliYSc_RqJLDFi4QKABybrSV1OTdLl0SK_45V07UMeta || {},
    component: () => import("/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___en",
    path: "/en/forgot-password",
    meta: forgot_45passwordgdzNcmliYSc_RqJLDFi4QKABybrSV1OTdLl0SK_45V07UMeta || {},
    component: () => import("/app/pages/forgot-password.vue")
  },
  {
    name: "payment-history___kk",
    path: "/kk/payment/history",
    meta: history5abFvAbdjq3Eo8BEFunaPrtazDD_45OQZFUuIjJch1EMwMeta || {},
    component: () => import("/app/pages/payment/history.vue")
  },
  {
    name: "payment-history___ru",
    path: "/payment/history",
    meta: history5abFvAbdjq3Eo8BEFunaPrtazDD_45OQZFUuIjJch1EMwMeta || {},
    component: () => import("/app/pages/payment/history.vue")
  },
  {
    name: "payment-history___en",
    path: "/en/payment/history",
    meta: history5abFvAbdjq3Eo8BEFunaPrtazDD_45OQZFUuIjJch1EMwMeta || {},
    component: () => import("/app/pages/payment/history.vue")
  },
  {
    name: "payment-add-card___kk",
    path: "/kk/payment/add-card",
    meta: add_45card_34dcmAYIGcGfP6yZ6nE_45iNoExkt6UFgd98lDp69VDsMeta || {},
    component: () => import("/app/pages/payment/add-card.vue")
  },
  {
    name: "payment-add-card___ru",
    path: "/payment/add-card",
    meta: add_45card_34dcmAYIGcGfP6yZ6nE_45iNoExkt6UFgd98lDp69VDsMeta || {},
    component: () => import("/app/pages/payment/add-card.vue")
  },
  {
    name: "payment-add-card___en",
    path: "/en/payment/add-card",
    meta: add_45card_34dcmAYIGcGfP6yZ6nE_45iNoExkt6UFgd98lDp69VDsMeta || {},
    component: () => import("/app/pages/payment/add-card.vue")
  },
  {
    name: "payment-checkout___kk",
    path: "/kk/payment/checkout",
    meta: checkoutQZu9KgMNqtNDnVL3wPsq_459Hgb4RiM2vFF1ZXYOnGVPQMeta || {},
    component: () => import("/app/pages/payment/checkout.vue")
  },
  {
    name: "payment-checkout___ru",
    path: "/payment/checkout",
    meta: checkoutQZu9KgMNqtNDnVL3wPsq_459Hgb4RiM2vFF1ZXYOnGVPQMeta || {},
    component: () => import("/app/pages/payment/checkout.vue")
  },
  {
    name: "payment-checkout___en",
    path: "/en/payment/checkout",
    meta: checkoutQZu9KgMNqtNDnVL3wPsq_459Hgb4RiM2vFF1ZXYOnGVPQMeta || {},
    component: () => import("/app/pages/payment/checkout.vue")
  },
  {
    name: "prescription-new___kk",
    path: "/kk/prescription/new",
    meta: newEVaGznpi9BLqkzSTCRr_3b9t6GmJGBWnjXpIG4gFA9cMeta || {},
    component: () => import("/app/pages/prescription/new.vue")
  },
  {
    name: "prescription-new___ru",
    path: "/prescription/new",
    meta: newEVaGznpi9BLqkzSTCRr_3b9t6GmJGBWnjXpIG4gFA9cMeta || {},
    component: () => import("/app/pages/prescription/new.vue")
  },
  {
    name: "prescription-new___en",
    path: "/en/prescription/new",
    meta: newEVaGznpi9BLqkzSTCRr_3b9t6GmJGBWnjXpIG4gFA9cMeta || {},
    component: () => import("/app/pages/prescription/new.vue")
  },
  {
    name: "test-credit-card___kk",
    path: "/kk/test-credit-card",
    component: () => import("/app/pages/test-credit-card.vue")
  },
  {
    name: "test-credit-card___ru",
    path: "/test-credit-card",
    component: () => import("/app/pages/test-credit-card.vue")
  },
  {
    name: "test-credit-card___en",
    path: "/en/test-credit-card",
    component: () => import("/app/pages/test-credit-card.vue")
  },
  {
    name: "debug-credit-card___kk",
    path: "/kk/debug-credit-card",
    component: () => import("/app/pages/debug-credit-card.vue")
  },
  {
    name: "debug-credit-card___ru",
    path: "/debug-credit-card",
    component: () => import("/app/pages/debug-credit-card.vue")
  },
  {
    name: "debug-credit-card___en",
    path: "/en/debug-credit-card",
    component: () => import("/app/pages/debug-credit-card.vue")
  },
  {
    name: "payment-credit-card___kk",
    path: "/kk/payment/credit-card",
    meta: credit_45cardXn9Lo4EF8ivB5Kmy6nw3VDwWzJMXW_4IG0F2L5A6NFkMeta || {},
    component: () => import("/app/pages/payment/credit-card.vue")
  },
  {
    name: "payment-credit-card___ru",
    path: "/payment/credit-card",
    meta: credit_45cardXn9Lo4EF8ivB5Kmy6nw3VDwWzJMXW_4IG0F2L5A6NFkMeta || {},
    component: () => import("/app/pages/payment/credit-card.vue")
  },
  {
    name: "payment-credit-card___en",
    path: "/en/payment/credit-card",
    meta: credit_45cardXn9Lo4EF8ivB5Kmy6nw3VDwWzJMXW_4IG0F2L5A6NFkMeta || {},
    component: () => import("/app/pages/payment/credit-card.vue")
  },
  {
    name: "prescription-search___kk",
    path: "/kk/prescription/search",
    meta: searchppJMDPGZclD1xLVE6OUI8g9TGEgi_1JItMEQe1LI_4580Meta || {},
    component: () => import("/app/pages/prescription/search.vue")
  },
  {
    name: "prescription-search___ru",
    path: "/prescription/search",
    meta: searchppJMDPGZclD1xLVE6OUI8g9TGEgi_1JItMEQe1LI_4580Meta || {},
    component: () => import("/app/pages/prescription/search.vue")
  },
  {
    name: "prescription-search___en",
    path: "/en/prescription/search",
    meta: searchppJMDPGZclD1xLVE6OUI8g9TGEgi_1JItMEQe1LI_4580Meta || {},
    component: () => import("/app/pages/prescription/search.vue")
  },
  {
    name: "prescription-history___kk",
    path: "/kk/prescription/history",
    meta: historynXI1xHYCYR7Kf_455OM1ZP8orwhnfsMMgSm4vGJJ4FzVYMeta || {},
    component: () => import("/app/pages/prescription/history.vue")
  },
  {
    name: "prescription-history___ru",
    path: "/prescription/history",
    meta: historynXI1xHYCYR7Kf_455OM1ZP8orwhnfsMMgSm4vGJJ4FzVYMeta || {},
    component: () => import("/app/pages/prescription/history.vue")
  },
  {
    name: "prescription-history___en",
    path: "/en/prescription/history",
    meta: historynXI1xHYCYR7Kf_455OM1ZP8orwhnfsMMgSm4vGJJ4FzVYMeta || {},
    component: () => import("/app/pages/prescription/history.vue")
  },
  {
    name: "payment-bonus-history___kk",
    path: "/kk/payment/bonus-history",
    meta: bonus_45historyRcxraFtnnVtr8cyUQlMjoZ3Q0goJSGWyoOyDvKWOTt4Meta || {},
    component: () => import("/app/pages/payment/bonus-history.vue")
  },
  {
    name: "payment-bonus-history___ru",
    path: "/payment/bonus-history",
    meta: bonus_45historyRcxraFtnnVtr8cyUQlMjoZ3Q0goJSGWyoOyDvKWOTt4Meta || {},
    component: () => import("/app/pages/payment/bonus-history.vue")
  },
  {
    name: "payment-bonus-history___en",
    path: "/en/payment/bonus-history",
    meta: bonus_45historyRcxraFtnnVtr8cyUQlMjoZ3Q0goJSGWyoOyDvKWOTt4Meta || {},
    component: () => import("/app/pages/payment/bonus-history.vue")
  }
]